import { CartItem } from '@/types/cart.types';

export const TELEHEALTH_IMPORTANT_INFO
  = 'Informamos que a emissão de atestados ou declarações médicas é uma atribuição exclusiva do profissional '
    + 'médico, conforme o Código de Ética Médica (Resolução CFM nº 2.217/2018). Essa prerrogativa não se estende '
    + 'a outros profissionais da saúde, como psicólogos, nutricionistas ou fonoaudiólogos.';

export const FOLLOW_UP_TAG = 'Aceita retorno';

export interface GuidanceBlock {
  id: string;
  procedureName: string;
  tags: string[];
  instructions?: string;
}

const years = (age: number): string => (age === 1 ? '1 ano' : `${age} anos`);

export function formatAgeRangeTag(minAge?: number, maxAge?: number): string | undefined {
  const max = typeof maxAge === 'number' && maxAge > 0 ? maxAge : undefined;
  const min = typeof minAge === 'number' && minAge > 0 ? minAge : 0;

  if (max !== undefined) {
    return `Faixa etária: ${min} a ${years(max)}`;
  }

  return min > 0 ? `Faixa etária: a partir de ${years(min)}` : undefined;
}

function buildTags(item: CartItem): string[] {
  const tags: string[] = [];
  const ageRange = formatAgeRangeTag(item.slot.minAge, item.slot.maxAge);

  if (ageRange) {
    tags.push(ageRange);
  }

  if (item.slot.followUp && item.slot.followUp > 0) {
    tags.push(FOLLOW_UP_TAG);
  }

  return tags;
}

export function hasTelehealthItem(items: CartItem[]): boolean {
  return items.some((item) => item.procedure.isTelehealth);
}

export function buildGuidanceBlocks(items: CartItem[]): GuidanceBlock[] {
  return items.map((item) => ({
    id: item.id,
    procedureName: item.procedure.alias || item.procedure.name,
    tags: buildTags(item),
    instructions: item.procedure.instructions?.trim() || undefined,
  }));
}
